export default __webpack_public_path__ + "static/media/downloadIcon.fdf1a5a8.svg";